import { useEffect } from "react";

import { findPageDescriptorByPath, pm2SitemapStore } from "@pm2/sitemap-utils";
import { useLocation, useNavigationManager } from "@provider/navigation";
import { useTrackingManager } from "@provider/tracking";

let sentBaseEvents = false;

/**
 * basic hook that should be added to the root of all apps integrating the
 * tracking provider while also utilising event tracking.
 */
export function useBaseEventsTracking() {
  const tracker = useTrackingManager();
  const navigation = useNavigationManager();
  const location = useLocation();
  const sitemapStore = pm2SitemapStore.useStore();

  useEffect(() => {
    if (sentBaseEvents) {
      return;
    }

    tracker.trackEvent("base.sessionStarted");

    const descriptor = findPageDescriptorByPath(
      sitemapStore.getState(),
      location.asPath,
    );

    tracker.trackEvent("userarea.navigation.toContent", {
      method: "deep-link",
      to: location.asPath,
      targetType: descriptor?.type ?? "Page",
    });

    sentBaseEvents = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return navigation.subscribe(() => {
      const location = navigation.getLocation();
      const descriptor = findPageDescriptorByPath(
        sitemapStore.getState(),
        location.asPath,
      );

      if (!descriptor) {
        return;
      }

      tracker.trackEvent("base.navigation", {
        id: descriptor.id,
        path: descriptor.path,
        title: descriptor.title,
        type: descriptor.type,
      });
    });
  }, [navigation, sitemapStore, tracker]);
}
